import { Store, applyMiddleware, combineReducers, createStore } from "redux";
import { thunk } from "redux-thunk";
import { useMemo } from "react";
import { accountReducer } from "@/domains/account/slice";
import { activeKeyReducer } from "@/domains/activeKey/slice";
import { authReducer } from "@/domains/auth/slice";
import { barbershopReducer } from "@/domains/barbershop/slice";
import { businessReducer } from "@/domains/business/slice";
import { chatReducer } from "@/domains/chat/slice";
import { createCharacterReducer } from "@/domains/createCharacter/slice";
import { estateReducer } from "@/domains/estate/slice";
import { factionReducer } from "@/domains/faction/slice";
import { gasStationReducer } from "@/domains/gasStation/slice";
import { inventoryReducer } from "@/domains/inventory/slice";
import { layerReducer } from "@/domains/layer/slice";
import { offerReducer } from "@/domains/offer/slice";
import { pcReducer } from "@/domains/pc/slice";
import { phoneReducer } from "@/domains/phone/slice";
import { playerReducer } from "@/domains/player/slice";
import { shopReducer } from "@/domains/shop/slice";
import { spawnReducer } from "@/domains/spawn/slice";
import { tabletReducer } from "@/domains/tablet/slice";
import { tattooParlorReducer } from "@/domains/tattooParlor/slice";
import { basicSettingsReducer } from "@/domains/settings/basic/slice";
import { chatSettingsReducer } from "@/domains/settings/chat/slice";
import { controlSettingsReducer } from "@/domains/settings/control/slice";
import { gameplaySettingsReducer } from "@/domains/settings/gameplay/slice";
import { soundSettingsReducer } from "@/domains/settings/sound/slice";

let store: Store | undefined;

const rootReducer = combineReducers({
  auth: authReducer,
  createCharacter: createCharacterReducer, // TODO: перевести на zustand
  account: accountReducer,
  inventory: inventoryReducer, // TODO: перевести на zustand
  chat: chatReducer,
  spawn: spawnReducer, // TODO: перевести на zustand
  barbershop: barbershopReducer,
  tattooParlor: tattooParlorReducer,
  estate: estateReducer, // TODO: перевести на zustand
  activeKey: activeKeyReducer,
  layer: layerReducer,
  gasStation: gasStationReducer, // TODO: перевести на zustand
  player: playerReducer, // TODO: сделать инъектцию для usePlayer
  offer: offerReducer, // TODO: перевести на zustand
  tablet: tabletReducer, // TODO: перевести на zustand
  business: businessReducer,
  chatSettings: chatSettingsReducer,
  basicSettings: basicSettingsReducer,
  soundSettings: soundSettingsReducer,
  gameplaySettings: gameplaySettingsReducer,
  controlSettings: controlSettingsReducer,
  shop: shopReducer,
  pc: pcReducer,
  faction: factionReducer,
  phone: phoneReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

// eslint-disable-next-line
const RDE = typeof window !== "undefined" && (window as any).__REDUX_DEVTOOLS_EXTENSION__;

function initStore(preloadedState?: Partial<RootState>): Store {
  const middlewares = [thunk]; // Добавляем redux-thunk в middlewares

  return createStore(
    rootReducer,
    preloadedState,
    typeof window !== "undefined" && RDE
      ? RDE(applyMiddleware(...middlewares))
      : applyMiddleware(...middlewares),
  );
}

export function initializeStore(preloadedState: Partial<RootState> = {}): Store {
  let newStore = store ?? initStore(preloadedState);

  if (preloadedState && store) {
    newStore = initStore({
      ...store.getState(),
      ...preloadedState,
    });
    store = undefined;
  }

  if (typeof window === "undefined") return newStore;
  if (!store) store = newStore;

  return newStore;
}

export function useStore(initialState: Partial<RootState> = {}): Store {
  return useMemo(() => initializeStore(initialState), [initialState]);
}
